import React from 'react';
import { DataCard } from '../../../common';
import { formatNumberWithCommas } from '../../../../utils/numbers';
import styles from './styles/cards-row.module.scss';

function CardsRow({ consumer }) {
    const data = [
        {
            title: 'Total Advances',
            subtitle: 'This is the total number of advances the user has made.',
            amount: consumer.totalAdvances,
            isCurrency: false,
            percentage: `Avg ${consumer.totalAdvanceAverage} / Pay Period`,
        },
        {
            title: 'Advances ($)',
            subtitle: 'This is the total amount of advances the user has made.',
            amount: consumer.advanceAmount,
            isCurrency: true,
            percentage: `Avg  $${formatNumberWithCommas(consumer.advanceAverage, true)} / Pay Period`,
        },
        {
            title: 'Fees ($)',
            subtitle: 'This is the total amount of fees the user has paid.',
            amount: consumer.feesAmount,
            isCurrency: true,
            percentage: `Avg  $${formatNumberWithCommas(consumer.feeAverage, true)} / Pay Period`,
        },
    ];
    return (
        <div className={styles.container}>
            {data.map((item, index) => (
                <DataCard
                    key={index}
                    title={item.title}
                    subtitle={item.subtitle}
                    amount={item.amount}
                    isCurrency={item.isCurrency}
                    isPercentage={false}
                    isTitle={false}
                    percentage={item.percentage}
                />
            ))}
        </div>
    );
}

export default CardsRow;
